// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-header[data-v-dbcc561e] {\n  font-weight: 600;\n}\n.c-list-item-group.theme--light[data-v-dbcc561e] {\n  background-color: white;\n}\n.c-list-item-group.theme--dark[data-v-dbcc561e] {\n  background-color: black;\n}\n.c-list-item--active[data-v-dbcc561e] {\n  background-color: var(--v-accent-base);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
